import React, { Component, Fragment } from 'react';

import './style.scss';
import FinancialCalendar from '../../../components/FinancialCalendar';
import { PDFIcon } from '../../../components/Icon/Icon';

export default class Grid extends Component {
    constructor(props) {
        super(props);
        this.state = {
            subview: null,
            data: require('./data/' + this.props.shortname + '.json'),
        };
    }
    onSubItemView = key => {
        if (this.state.subview === key) {
            this.setState({
                subview: null,
            });
        } else {
            this.setState({
                subview: key,
            });
        }
    };
    render() {
        const { data, subview } = this.state;
        if (data.column) {
            return <FinancialCalendar />;
        } else {
            return (
                <Fragment>
                    <ul className="grid-slim">
                        {data.items.map((item, key) => {
                            if (item.subitems && item.subitems.length > 0) {
                                return (
                                    <li key={key} className={subview === key ? 'selected' : null}>
                                        {subview === key ? (
                                            <ul className="subitems">
                                                {item.subitems.map((item, key) => {
                                                    return (
                                                        <li key={key}>
                                                            <a
                                                                href={item.url}
                                                                alt={item.text}
                                                                title={item.text}
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                <i></i>
                                                                {item.text}
                                                            </a>
                                                        </li>
                                                    );
                                                })}
                                            </ul>
                                        ) : (
                                            <div
                                                className={item.icon ? 'has-icon' : 'just-text'}
                                                onClick={this.onSubItemView.bind(this, key)}
                                            >
                                                {item.icon ? (
                                                    this.props.shortname === 'gender-pay-gap' ? (
                                                        <PDFIcon
                                                            name="gender-pay-gap-report/gender-pay-gap.png"
                                                            style={{ filter: 'invert(1)' }}
                                                        />
                                                    ) : (
                                                        <i></i>
                                                    )
                                                ) : null}
                                                <p>{item.text}</p>
                                                {item.icon ? null : <span></span>}
                                            </div>
                                        )}
                                    </li>
                                );
                            } else {
                                return (
                                    <li key={key}>
                                        <a
                                            href={item.url}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            title={item.text}
                                        >
                                            <div className={item.icon ? null : 'just-text'}>
                                                {item.icon ? <i></i> : null}
                                                {item.text}
                                            </div>
                                        </a>
                                    </li>
                                );
                            }
                        })}
                    </ul>
                    {this.props.shortname === 'shareholder-information' ? (
                        <ul className="shareholder">
                            <li>
                                FCA warning
                                <br />
                                Warning to shareholders - boiler room scams.{' '}
                                <a
                                    href="https://files.jdplc.com/pdf/FCA-Beware-of-Share-Fraud.pdf"
                                    className="link"
                                    title="FCA Share Fraud"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    Please read
                                </a>{' '}
                                for your own protection.
                            </li>
                            <li>
                                Share information
                                <br />
                                Shares are quoted on the London Stock Exchange under the symbol JD.
                            </li>
                        </ul>
                    ) : null}
                </Fragment>
            );
        }
    }
}
